module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-components"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.wrapperList), function(wrapper) {
    return _c('div', {
      class: wrapper.class
    }, _vm._l((wrapper.componentList), function(component) {
      return _c('div', {
        class: component.class
      }, _vm._l((component.itemList), function(item) {
        return _c('div', {
          class: item.class
        }, [(item.content && item.content.type === 'title') ? _c('p', {
          staticClass: "title"
        }, [_vm._v(_vm._s(item.content.title))]) : _vm._e(), _vm._v(" "), (item.content && item.content.type === 'title') ? _c('p', {
          staticClass: "subtitle"
        }, [_vm._v(_vm._s(item.content.subtitle))]) : _vm._e(), _vm._v(" "), (!component.nocontrol) ? _c('div', {
          staticClass: "columns"
        }, [_c('div', {
          staticClass: "column has-text-right"
        }, [_c('p', [_c('a', {
          on: {
            "click": function($event) {
              _vm.addComponent(wrapper.componentList, 1);
              component.nocontrol = true
            }
          }
        }, [_vm._v("add column "), _c('i', {
          staticClass: "material-icons md-18"
        }, [_vm._v("arrow_forward")])])])])]) : _vm._e()])
      }))
    }))
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "box content",
    staticStyle: {
      "background-color": "#eee"
    }
  }, [_c('p', [_c('a', {
    on: {
      "click": function($event) {
        _vm.addComponents(_vm.wrapperList, 1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("arrow_downward")]), _vm._v(" add row")])])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Components")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Components")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-043cc9da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages_test/Components.vue
// module id = 796
// module chunks = 1